import _extends from "@babel/runtime/helpers/esm/extends";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import { Muted, Unmuted } from '@magalu/stereo-ui-icons';
import React, { useEffect, useState, useMemo, useCallback } from 'react';
import PropTypes from 'prop-types';
import { buildVideoProgressionEventData } from '../../../AdsBanner/AdsBanner.utils';
import { usePublisher } from '@magalu/mixer-publisher';
import { useHlsVideo } from '../../../../../hooks/useHlsVideo';
import { MuteButton, StyledVideo, VideoWrapper } from './styles';
var AdsBrandVideo = function AdsBrandVideo(_ref) {
  var adsPath = _ref.adsPath,
    banner = _ref.banner,
    styles = _ref.styles,
    height = _ref.height,
    inView = _ref.inView,
    width = _ref.width;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isLoaded = _useState2[0],
    setIsLoaded = _useState2[1];
  var _usePublisher = usePublisher(),
    publish = _usePublisher.publish;
  var eventData = useMemo(function () {
    return {
      ad_type: 'sponsored_brands',
      creative_slot: adsPath,
      video_title: banner.videoTitle || '',
      video_url: banner.imageUrl
    };
  }, [banner.imageUrl, adsPath, banner.videoTitle]);
  var handleStart = useCallback(function (videoInfo) {
    publish('promotion:video:start', _extends({}, eventData, buildVideoProgressionEventData(videoInfo)));
  }, [publish, eventData]);
  var handleComplete = useCallback(function (videoInfo) {
    publish('promotion:video:complete', _extends({}, eventData, buildVideoProgressionEventData(videoInfo)));
  }, [publish, eventData]);
  var handleProgress = useCallback(function (videoInfo) {
    publish('promotion:video:progress', _extends({}, eventData, buildVideoProgressionEventData(videoInfo)));
  }, [publish, eventData]);
  var _useHlsVideo = useHlsVideo({
      autoPlay: true,
      onComplete: handleComplete,
      onProgress: handleProgress,
      onStart: handleStart,
      videoUrl: banner.imageUrl
    }),
    videoRef = _useHlsVideo.videoRef,
    isMuted = _useHlsVideo.isMuted,
    controls = _useHlsVideo.controls;
  useEffect(function () {
    if (isLoaded) {
      if (inView) {
        controls.play();
      } else {
        controls.pause();
      }
    }
  }, [inView, isLoaded, controls]);
  var handleMuteToggle = function handleMuteToggle(e) {
    e.preventDefault();
    e.stopPropagation();
    controls.toggleMute();
  };
  return React.createElement(VideoWrapper, {
    width: width,
    height: height
  }, React.createElement(StyledVideo, {
    "aria-label": "Banner de ofertas do Magazine Luiza",
    ref: videoRef,
    height: height,
    width: width,
    playsInline: true,
    loop: true,
    style: _extends({
      objectFit: 'fill'
    }, styles),
    onLoadedData: function onLoadedData() {
      return setIsLoaded(true);
    }
  }), isLoaded && React.createElement(MuteButton, {
    onClick: handleMuteToggle,
    onMouseDown: function onMouseDown(e) {
      return e.stopPropagation();
    },
    "aria-label": isMuted ? 'Ativar som do vídeo' : 'Desativar som do vídeo',
    type: "button"
  }, isMuted ? React.createElement(Muted, {
    width: 24,
    height: 24,
    color: "white"
  }) : React.createElement(Unmuted, {
    width: 24,
    height: 24,
    color: "white"
  })));
};
process.env.NODE_ENV !== "production" ? AdsBrandVideo.propTypes = {
  adsPath: PropTypes.string.isRequired,
  banner: PropTypes.shape({
    imageUrl: PropTypes.string.isRequired,
    videoTitle: PropTypes.string
  }).isRequired,
  height: PropTypes.string,
  inView: PropTypes.bool,
  styles: PropTypes.shape({}),
  width: PropTypes.string
} : void 0;
AdsBrandVideo.defaultProps = {
  height: '100%',
  inView: true,
  styles: {},
  width: '100%'
};
export default AdsBrandVideo;